// import customizableView from './customizableView'
export default angular
    .module('app.redevComponents', [
        // customizableView
    ])
    .name


//////////////////
// WEBPACK FOOTER
// ./redevelopment/common/components/index.js
// module id = DXmV
// module chunks = 0